;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"

// Plain Tailwind span/anchor (no hooks) so it renders inside the Server Component
// GroupCard with no client hydration.
const BUTTON_CLASSES =
  "flex h-[41px] w-[309px] max-w-full items-center justify-around rounded-[100px] bg-[#092C3C] px-[15px] text-center font-roboto text-[16px] font-medium leading-[19px] tracking-[0.48px] text-white no-underline transition-colors [filter:drop-shadow(0px_2px_2px_rgba(0,0,0,0.25))] hover:bg-[#32596a]"

type ViewGroupButtonProps = {
  /** Omit when the control sits inside a parent `Link` (avoids nested anchors). */
  href?: string
  text: string
}

export default function ViewGroupButton({ href, text }: ViewGroupButtonProps) {
  if (href) {
    return (
      <a href={href} className={BUTTON_CLASSES}>
        {text}
      </a>
    )
  }
  return (
    <span className={BUTTON_CLASSES} tabIndex={-1}>
      {text}
    </span>
  )
}
